class TrieNode {
  constructor() {
    this.metadata = [];
  }
}

export default class Trie {
  constructor() {
    this.root = new TrieNode();
  }

  add(value, metadata) {
    if (!value) return;
    let currentNode = this.root;
    const chars = value.toLowerCase().split("");
    chars.forEach((char, idx) => {
      currentNode[char] = currentNode[char] || new TrieNode();
      if (idx === chars.length - 1) {
        currentNode[char].metadata.push(metadata);
        return;
      }
      if (typeof metadata === "object") {
        currentNode[char].metadata.push(metadata);
      } else {
        currentNode[char].metadata.push(
          ((typeof metadata === "string" && metadata) || value).substring(
            idx + 1
          )
        );
      }
      currentNode = currentNode[char];
    });
  }

  findAllOccurrences(value) {
    return this.find(value, this.root);
  }

  find(value, startNode) {
    let result = [];
    if (!value) return undefined;

    let currentNode = startNode;
    let currentIdx = 0;
    const chars = value.toLowerCase();
    while (currentNode) {
      const char = chars[currentIdx];
      currentNode = currentNode[char];
      if (!currentNode) break;
      if (currentIdx === chars.length - 1) {
        result = currentNode.metadata;
        break;
      }
      currentIdx += 1;
    }

    /*
      Travers tree structure recursively to find all paths that match "value" occurrence
     */
    const restOfTheTree = Object.entries(startNode).reduce(
      (acc, [key, val]) =>
        key === "metadata" ? acc : [...acc, ...this.find(value, val)],
      []
    );

    return [...result, ...restOfTheTree];
  }
}
